import React from 'react';
import {Box,Flex} from 'rebass'
import RouterLink from './Link'

export default function NavBar2() {
    return (
        <div>
    <Flex
        width={1}
        height={55}
        px={3}
        backgroundColor="black"
        color='white'
        fontFamily='verdana'
        alignItems='center'
        justifyContent='center'>
        <Box p={2} margin='0' fontSize='3' color="white" sx={{textDecoration: 'none', fontWeight: 'bold'}}>
            WhiskeyMapper.com
        </Box>
    </Flex>

    <Flex
        width={1}
        height={40}
        px={0}
        backgroundColor="black"
        color='white'
        fontFamily='verdana'
        alignItems='center'>
        <Box mx='auto' />
        <RouterLink to="/Search">
            Search
        </RouterLink>
        <RouterLink to="/Experiment">
            Experiment
        </RouterLink>
        <RouterLink to="/About">
            About
        </RouterLink>
    </Flex>

    </div>
    
    );
}